import { getCmsDestinationBySlug } from "../../../app/api/getCmsDestinationBySlug";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  ICmsDestinationDetail,
  ICmsDestinationDetailResponse,
  IGetDestinationActionParams,
} from "../../../Orchestrator/Types/Interface/ICmsDestination";

class GetCmsDestinationDetailAction extends BaseAction<
  ICmsDestinationDetail[],
  IGetDestinationActionParams
> {
  override async run(): Promise<ICmsDestinationDetail[] | null> {
    let listOfDestinations: ICmsDestinationDetail[] = [];
    try {
      const { slug } = this.params!;
      const response: IApiResponse<ICmsDestinationDetailResponse> =
        await getCmsDestinationBySlug(slug);

      if (response.status === "ok" && response.answer) {
        const destinations = response.answer.data;
        if (destinations.length > 0) {
          listOfDestinations = destinations;
          updateRecoilState("destinationDetailAtom", listOfDestinations[0]);
        } else {
          updateRecoilState("destinationDetailAtom", null);
          console.warn("No destinations available.");
        }
      } else {
        console.warn("Failed to fetch destinations.");
      }
    } catch (error: any) {
      console.error("Error fetching destinations:", error);
    } finally {
      return listOfDestinations;
    }
  }
}

export const getCmsDestinationDetailAction =
  new GetCmsDestinationDetailAction();
